import React from "react";
import { Row, Col } from "../../components/ui/wrapper";
import Form, { FormGroup, Input, Checkbox, Error } from "../ui/form";

const JSPositionFormFields = ({register}) => {
    return (
        <>
            <Row gutters={{ md: 20 }} pl="0px" mb="20px">
              <Col md={12}>
                Front-end Skills (Choose all that apply)
              </Col>
            </Row>
            <Row gutters={{ lg: 20 }}  pl="0px">
              <Col md={2}>
                <FormGroup mb="20px">
                  <Checkbox
                    id="skillReact"
                    labelText="React"
                    {...register('skillReact')}
                  />
                </FormGroup>
              </Col>

              <Col md={2}>
                <FormGroup mb="20px">
                  <Checkbox
                    id="skillReactHooks"
                    labelText="React Hooks"
                    {...register('skillReactHooks')}
                  />
                </FormGroup>
              </Col>          

              <Col md={2}>
                <FormGroup mb="20px">
                  <Checkbox
                    id="skillTypescript"
                    labelText="Typescript"
                    {...register('skillTypescript')}
                  />
                </FormGroup>
              </Col>

              <Col md={2}>
                <FormGroup mb="20px">
                  <Checkbox
                    id="skillNextjs"
                    labelText="Next.js"
                    {...register('skillNextJs')}
                  />
                </FormGroup>
              </Col>

              <Col md={2}>
                <FormGroup mb="20px">
                  <Checkbox
                    id="skillGatsby"
                    labelText="Gatsby"
                    {...register('skillGatsby')}
                  />
                </FormGroup>
              </Col>

              <Col md={2}>
                <FormGroup mb="20px">
                  <Checkbox
                    id="skillCssInJs"
                    labelText="CSS-In-JS"
                    {...register('skillCssInJs')}
                  />
                </FormGroup>
              </Col>          
            </Row>
            <Row gutters={{ md: 20 }} pl="0px" mb="20px">
              <Col md={12}>
                Server-side Skills (Choose all that apply)
              </Col>
            </Row>
            <Row gutters={{ lg: 20 }} >
              <Col md={2}>
                <FormGroup mb="20px">
                  <Checkbox
                    id="skillNode"
                    labelText="Node.js"
                    {...register('skillNode')}
                  />
                </FormGroup>
              </Col>

              <Col md={2}>
                <FormGroup mb="20px">
                  <Checkbox
                    id="skillExpress"
                    labelText="Express"
                    {...register('skillExpress')}
                  />
                </FormGroup>
              </Col>          

              <Col md={2}>
                <FormGroup mb="20px">
                  <Checkbox
                    id="skillNestJS"
                    labelText="NestJS"
                    {...register('skillNestJS')}
                  />
                </FormGroup>
              </Col>

              <Col md={2}>
                <FormGroup mb="20px">
                  <Checkbox
                    id="skillGraphQL"
                    labelText="GraphQL"
                    {...register('skillGraphQL')}
                  />
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup mb="20px">
                  <Checkbox
                    id="skillRDBMS"
                    labelText="Relational Databases"
                    {...register('skillRDBMS')}
                  />
                </FormGroup>
              </Col>
  
            </Row>
          
        </>
    )
}

export { JSPositionFormFields }